import { TripLegSearchMenu } from '../requests/trip-legs';

export interface TripLegExceptionSelection {
  description: string;
  isActive: boolean;
  tripLegExceptionID: number;
  tripLegExceptionBC: string;
  menu: TripLegSearchMenu;
  tripLegExceptionName: string;
}

export enum TripLegExceptionBC {
  OpenSameDay = 'OPENSAMEDAY',
  NoDriver = 'NODRIVER',
  DriverNotOnline = 'DRIVERNOTONLINE',
  DriverLate = 'DRIVERLATE',
  EtaNotUpdating = 'ETANOTUPDATING',
  ReadyInvoice = 'READYINVOICE',
}
